import base from "@/store/utils/api-route/base";

const layananApi = {
	list: {
		default: "",
		konsumen: `${base.meta}list_layanan_konsumen`,
		owner: `${base.meta}list_layanan_owner_tiny`,
	}
}

export default layananApi